module.exports = __webpack_public_path__ + "img/1544213268.b309bf32.jpg";